import React from "react";
import { func, bool } from "prop-types";
import "./hamburger.m.css";

const HamburgerIcon = ({ onMenuToggle, isNavbarOpen, isDesktop }) => {
  return (
    <div
      onClick={onMenuToggle}
      styleName={`hamburger ${!isDesktop && isNavbarOpen ? "is-open" : ""}`}
      className="hamburger"
      aria-label="Close"
    >
      <div styleName="line" className="hamburger-line" />
      <div styleName="line" className="hamburger-line" />
      <div styleName="line" className="hamburger-line" />
    </div>
  );
};

export default HamburgerIcon;

HamburgerIcon.propTypes = {
  onMenuToggle: func,
  isNavbarOpen: bool,
  isDesktop: bool
};
